import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { photoUrl } from "../lib/api";
import { priceLabel, geocodeListing, PROV_CENTER } from "../lib/constants";

const pinIcon = L.divIcon({
  className: "critter-pin",
  html: `<div style="position:relative;width:30px;height:40px">
    <svg width="30" height="40" viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill="#F5551E"/>
      <circle cx="15" cy="15" r="6" fill="#ffffff"/>
    </svg></div>`,
  iconSize: [30, 40],
  iconAnchor: [15, 40],
  popupAnchor: [0, -38],
});

function FitBounds({ points, province }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) {
      map.setView(points[0], 10);
    } else if (points.length > 1) {
      map.fitBounds(L.latLngBounds(points).pad(0.2), { maxZoom: 11 });
    } else {
      map.setView(PROV_CENTER[province] || PROV_CENTER.all, province === "all" ? 4 : 5);
    }
  }, [points, province, map]);
  return null;
}

export const ListingsMap = ({ listings, province }) => {
  const marked = useMemo(
    () => listings.map((l) => ({ ...l, pos: geocodeListing(l) })),
    [listings]
  );
  const points = marked.map((m) => m.pos);

  return (
    <div className="rounded-2xl overflow-hidden border border-slate-200 h-[600px] sticky top-20" data-testid="listings-map">
      <MapContainer
        center={PROV_CENTER[province] || PROV_CENTER.all}
        zoom={province === "all" ? 4 : 5}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} province={province} />
        {marked.map((l) => (
          <Marker key={l.id} position={l.pos} icon={pinIcon}>
            <Popup>
              <Link to={`/listing/${l.id}`} data-testid={`map-pin-${l.id}`} className="block w-44">
                <img src={photoUrl((l.photos || [])[0])} alt="" className="h-24 w-full rounded-lg object-cover bg-slate-100" />
                <p className="font-semibold text-[#12234A] text-sm mt-1.5 leading-tight">{l.title}</p>
                <p className="text-[#F5551E] font-bold text-sm">{priceLabel(l)}</p>
                <p className="text-xs text-slate-500">{l.city}, {l.province}</p>
                <span className="text-xs text-[#F5551E] font-semibold">View listing →</span>
              </Link>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
